module.exports = __webpack_public_path__ + "img/banner4.1328bf7e.png";